import { Component } from "react";
import { AlertTriangle, RotateCcw, Home } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-navy flex flex-col items-center justify-center px-6 text-center" data-testid="error-boundary">
        <div className="w-16 h-16 border border-gold flex items-center justify-center text-gold mb-8"><AlertTriangle size={28} /></div>
        <h1 className="font-heading text-3xl md:text-4xl text-white mb-4">Something went wrong</h1>
        <p className="text-gray-400 max-w-md mb-10">An unexpected error occurred. You can reload the page or head back home — your work is safe.</p>
        <div className="flex gap-4 flex-wrap justify-center">
          <button onClick={() => window.location.reload()} data-testid="error-reload"
            className="flex items-center gap-2 bg-gold text-navy px-7 py-3.5 font-semibold hover:bg-gold-light transition-colors">
            <RotateCcw size={16} /> Reload page
          </button>
          <a href="/" data-testid="error-home"
            className="flex items-center gap-2 border border-white/25 text-white px-7 py-3.5 hover:bg-white/5 transition-colors">
            <Home size={16} /> Back to home
          </a>
        </div>
      </div>
    );
  }
}
